module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.9aa97439.svg";